import { AppDispatch } from '../../data/store';
import { WebSocketSessionInfo } from './webSocketService';
import { TripLegProviderNoteType } from '../../data/models/note.model';
import * as providerSlice from '../../data/provider.slice';

interface IInternalNoteDetail {
  tripLegID: number;
  note: TripLegProviderNoteType;
}

interface IInternalNoteCommentDetail {
  transportationProviderID: number;
  transportationProviderNoteID: string;
  noteComment: TripLegProviderNoteType;
}

enum InternalNoteEventType {
  TripLegInternalNoteAdded = 'TripLegInternalNoteAdded',
}

/**
 * Method for handling all Internal Note Events
 * @param sessionInfo The webSocketService sessionInfo object. Contains data copied over from the Redux store as needed
 * @param dispatch The Redux store dispatch function
 * @param detailType A string representing the type of event. Must be one of the TripLegEventType enum values
 * @param detail An object containing the event data, in this case a TripLeg
 */
function updateInternalNote(
  sessionInfo: WebSocketSessionInfo,
  dispatch: AppDispatch,
  detailType: string,
  detail: TripLegProviderNoteType,
) {
  switch (detailType) {
    case InternalNoteEventType.TripLegInternalNoteAdded:
      dispatch(providerSlice.upsertInternalNote(detail));
      break;
    default:
      break;
  }
}

export { InternalNoteEventType, updateInternalNote };
